/**
 * The route test's first drop against the country window, and whose numbers
 * the formula reads (moved out of RouteTestStep, 21/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { earliestDropMinute, type RouteTestClock, type RouteTestSource } from '@trafficpulse/shared';

import { SegmentedPills } from '@/components/ui';

import { clockText } from '../../../../utils/clock/dk-label';
import type { CountryClock } from '../../../shared/time/country-clock-context';

const SOURCE_LINE: Record<RouteTestSource, string> = {
  drops: 'Drop stats — this route test’s own drops from today, with SMSWiser’s delivery numbers (Delivered Rate, SMS Sent…) next to the tracker’s. Other containers are not counted.',
  gateway:
    'Gateway stats — each gateway’s own numbers from today. The sender is still the best one on this route test’s drops through that gateway.',
};

/** A country minute, Danish first ("23:30 −1d 🇩🇰 · 🇦🇺 08:30"); "the window" when the first drop waits for it. */
const minuteLabel = (minute: number | null, page: CountryClock): string => (minute === null ? 'the window' : clockText(minute, page));

export const ClockNote: FC<{ clock: RouteTestClock; problem: string | null; windowStartMin: number; page: CountryClock }> = ({ clock, problem, windowStartMin, page }) => (
  <>
    {problem && clock.strategy === 'ROUTE_TEST' ? <p className="text-xs text-warning">{problem}</p> : null}
    <p className="text-xs text-muted-foreground">
      First drop at {minuteLabel(earliestDropMinute(clock), page)} · window opens {minuteLabel(windowStartMin, page)}
    </p>
  </>
);

export const NumbersFrom: FC<{ source: RouteTestSource; onChange: (next: RouteTestSource) => void }> = ({ source, onChange }) => (
  <div className="flex flex-col gap-1.5 rounded-lg border border-border/70 bg-muted/20 px-3 py-2.5">
    <SegmentedPills
      label="Numbers from"
      options={[
        { value: 'drops', label: 'Drop stats' },
        { value: 'gateway', label: 'Gateway stats' },
      ]}
      value={source}
      onChange={onChange}
    />
    <p className="text-xs text-muted-foreground">{SOURCE_LINE[source]}</p>
  </div>
);
